module.exports = __webpack_public_path__ + "static/media/switch-light.d3b3c58e.svg";